export const GET_EXPORT_LOCATION = "GET_EXPORT_LOCATION";
export const GET_EXPORT_LOCATION_SUCCESS = "GET_EXPORT_LOCATION_SUCCESS";
export const GET_EXPORT_LOCATION_ERROR = "GET_EXPORT_LOCATION_ERROR";

export const POST_EXPORT_LOCATION = "POST_EXPORT_LOCATION";
export const POST_EXPORT_LOCATION_SUCCESS = "POST_EXPORT_LOCATION_SUCCESS";
export const POST_EXPORT_LOCATION_ERROR = "POST_EXPORT_LOCATION_ERROR";
